import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { formatDate } from '../../utils';
import * as storage from '../../utils/storage'
import i18next from 'i18next';
import PropTypes from 'prop-types'
import { IsEnglish } from '../../utils/language'
import styles from '../../styles/request.module.css';
import { isIOS } from '../../utils';

const useStyles = makeStyles({
    table: {
        '& td': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        '& td:first-child': {
            width: '30%',
            '@media (max-width: 600px)': {
                width: '50%'
            }
        },
    },
    head: {
        lineHeight: '0.5'
    },
    labelSubCode: {
        textAlign: 'right'
    }
});

const StyledFirstTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "150px"
        },
        fontWeight: "bold"
    },
}))(TableCell);

const StyledSecondTableCell = withStyles((theme) => ({
    head: {
        color: '#000000!important',
        fontSize: 16,
        width: '75%',
        '@media (max-width: 600px)': {
            fontSize: 12,
            width: "75%"
        },
        fontWeight: 'bold'
    },
    body: {
        fontSize: 16,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

const StyledCommentTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "150px"
        },
        fontWeight: "bold"
    },
}))(TableCell);

export default function RequestDetailVacationDisplay(props) {

    const classes = useStyles();
    const { data, dataRequest } = props;
    const [isiOS, setIsiOS] = React.useState(isIOS());

    useEffect(() => {
        resizeForm();
    }, [])

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = isiOS ? 73 : 63;

            const customHeight = height - titleBar - offSet;

            const element = document.querySelector('#divDetailLeave');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 100);
    }

    return (
        <React.Fragment>
            <div id="divDetailLeave" className={styles.detailRequest}>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableBody>
                            <TableRow>
                                <StyledFirstTableCell>Type</StyledFirstTableCell>
                                <StyledSecondTableCell>{IsEnglish() ? data.requestTypeEn : data.requestTypeFr}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("request:form.status")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.statusDescription}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("request:form.partial")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{i18next.t(`request:table.${dataRequest.isPartial ? "yes" : "no"}`)}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t(`request:${dataRequest.isPartial ? "table.request-date" : "form.startDate"}`)}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(dataRequest.startDate, 'date')}</StyledSecondTableCell>
                            </TableRow>
                            {!dataRequest.isPartial && <TableRow>
                                <StyledFirstTableCell>{i18next.t("request:form.endDate")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(dataRequest.endDate, 'date')}</StyledSecondTableCell>
                            </TableRow>}
                            {storage.getScheduleReturnDate() && <TableRow>
                                <StyledFirstTableCell>{i18next.t("request:form.scheduleReturnDate")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(dataRequest.returnDate, 'date')}</StyledSecondTableCell>
                            </TableRow>}
                            {dataRequest.isPartial && <TableRow>
                                <StyledFirstTableCell>{i18next.t("request:form.duration")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{`${parseFloat(dataRequest.duration)} (${IsEnglish() ? dataRequest.durationTypeEn : dataRequest.durationTypeFr})`}</StyledSecondTableCell>
                            </TableRow>}
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("request:form.vacation.paidAdvance")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{dataRequest.isAdvancedPay ? '' : i18next.t(`request:table.no`)}{dataRequest.isAdvancedPay ? (dataRequest.datePay != null ? formatDate(dataRequest.datePay, 'date') : i18next.t(`request:table.yes`)) : ''}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("request:form.comment")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{dataRequest.employeeComment}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t("request:table.approver-comment")}</StyledCommentTableCell>
                                <StyledSecondTableCell>{dataRequest.approverComment}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("request:table.approved")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{i18next.t(`request:table.${data.isApproved ? "yes" : "no"}`)}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("request:table.approver")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.approverName}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("request:table.approval-date")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(data.approvedDate)}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t("request:table.creation-date")}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(data.creationDate)}</StyledSecondTableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </React.Fragment>
    );
}

RequestDetailVacationDisplay.propTypes = {
    data: PropTypes.object.isRequired,
    dataRequest: PropTypes.object.isRequired
}